<script>
    import { Bar } from 'vue-chartjs'
    import createChart from './mixins/createChart'

    export default {
        extends: Bar,

        mixins: [createChart],

        props: {
            chartData: {
                type: Object,
                required: true,
                default: () => {}
            },

            options: {
                type: Object,
                default: () => {
                    return {
                        legend: {
                            display: false,
                        },

                        legendCallback: chart => {
                            let text = []

                            text.push(`<ul class="${chart.id}-legend block w-full mt-16">`)

                            for (const dataset of chart.data.datasets) {
                                if (!dataset.target) {
                                    text.push('<li class="whitespace-no-wrap inline-block text-14 mr-16 cursor-pointer">')
                                    text.push(`<span style="background-color:${dataset.backgroundColor}" class="inline-block w-14 h-14 mr-8"></span>`)
                                    text.push(dataset.label)
                                    text.push('</li>')
                                }
                            }

                            text.push('</ul>');

                            return text.join('');
                        },

                        scales: {
                            xAxes: [{
                                gridLines: {
                                    display: false
                                },
                                stacked: true,
                                ticks: {
                                    fontColor: '#fff',
                                    fontFamily: "'proxima-nova', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                                }
                            }],
                            yAxes: [{
                                gridLines: {
                                    color: '#40424F',
                                    drawTicks: false,
                                    drawBorder: 0
                                },
                                // stacked: true,
                                ticks: {
                                    beginAtZero: false,
                                    fontColor: '#fff',
                                    fontFamily: "'proxima-nova', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                                    padding: 2
                                }
                            }]
                        }
                    }
                }
            },

            scheme: {
                type: String,
                default: 'dark'
            },
        },

        data() {
            return {
                dataStyling: {
                    borderWidth: 0
                },
                targetDataStyling: {
                    borderColor: '#5E6075',
                    borderDash: [4, 4],
                    borderWidth: 1,
                    pointBorderWidth: 0
                },
            }
        },

        mounted () {
            this.options.scales.xAxes[0].ticks.fontColor = this.isDarkScheme ? '#fff' : '#000'
            this.options.scales.yAxes[0].ticks.fontColor = this.isDarkScheme ? '#fff' : '#000'

            this.createStackedBarChart()
            this.createCustomLegend('bottom')

            this.$on('chart:render', () => {
                this.createCustomLegend('bottom')
            })
        },

        methods: {
            createStackedBarChart() {
                let colorIndex = {}

                this.chartData.datasets.forEach((dataset, index) => {
                    if (!dataset.target) {
                        colorIndex[dataset.label] = this.stackedColors[index]
                        dataset.backgroundColor = this.stackedColors[index]
                        dataset.borderColor = this.stackedColors[index]
                        dataset.borderColor = this.stackedColors[index]
                        dataset.stack = 'Stack 0'
                    }
                })

                this.chartData.datasets.forEach((dataset, index) => {
                    if (dataset.target && !dataset.target_hidden) {
                        dataset.backgroundColor = colorIndex[dataset.label]
                        dataset.pointBackgroundColor = colorIndex[dataset.label]
                        dataset.pointBorderColor = colorIndex[dataset.label]
                    }

                    if (dataset.target_hidden) {
                        dataset.backgroundColor = this.isDarkScheme ? '#fff' : '#000'
                        dataset.pointBackgroundColor = this.isDarkScheme ? '#fff' : '#000'
                        dataset.pointBorderColor = this.isDarkScheme ? '#fff' : '#000'
                    }
                })

                this.createChart()
            },
        },
    }
</script>